import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import { useTopicsIndexContext } from 'hb-react/shared/apps/TopicsIndexV2/contexts/TopicsIndexContext';

import TopicLoadingCardBase from './TopicLoadingCardBase';

export const TopicLoadingCard = ({
  isConnectedUser,
  isStatic = false,
  noDescriptionPlaceholder,
}) => (
  <TopicLoadingCardBase isStatic={isStatic}>
    <Box>
      <Skeleton isStatic={isStatic} width="100%" height="30px" mt={3} />
    </Box>
    <Box>
      <Skeleton isStatic={isStatic} width="100%" height="30px" mt={3} />
    </Box>
    {isConnectedUser && !noDescriptionPlaceholder && (
      <Box display="block">
        <Divider mt={4} mb={3} />
        <Box>
          <Skeleton isStatic={isStatic} width="100%" height="34px" />
        </Box>
      </Box>
    )}
  </TopicLoadingCardBase>
);

TopicLoadingCard.propTypes = {
  isStatic: PropTypes.bool.isRequired,
};

export default ({ isStatic, noDescriptionPlaceholder }) => {
  const { isConnectedUser } = useTopicsIndexContext();

  return (
    <TopicLoadingCard
      isConnectedUser={isConnectedUser}
      isStatic={isStatic}
      noDescriptionPlaceholder={noDescriptionPlaceholder}
    />
  );
};

export { default as TopicLoadingCardBase } from './TopicLoadingCardBase';
